import { useTranslations } from 'next-intl'
import { useSession } from '@/hooks/use-session'
import { useRouter } from '@/i18n/navigation'
import { UserButton } from '@/app/[locale]/(global)/user-button'
import { Button } from '@/app/[locale]/(ui)/button'

export const SignInNewsBanner = () => {
  const { push } = useRouter()
  const { isSignedIn } = useSession()
  const t = useTranslations()

  return (
    <div className="relative my-10 flex w-full max-w-screen-sm flex-col gap-3 rounded-xl border border-black bg-white px-6 py-4 md:px-8 md:py-6">
      <h2 className="text-xl font-bold md:text-2xl">
        {isSignedIn ? t('You_are_signed_in') : t('Sign_in_with_business')}
      </h2>
      <p className="md:text-md">{t('Sign_in_banner_description')}</p>
      {isSignedIn ? (
        <Button variant="primary" onClick={() => push('/bedrifter')}>
          {t('Go_to_webshop')}
        </Button>
      ) : (
        <UserButton />
      )}
      {!isSignedIn && (
        <span className="absolute -right-5 -top-5 rounded-full border border-black bg-isekk p-3 py-1 font-bold max-md:right-5 md:text-xl">
          {t('News')}
        </span>
      )}
    </div>
  )
}
